import base from './dev'

base.env = 'deploy'

export default base



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/env/deploy.ts